import { render, staticRenderFns } from "./transactionRecords.vue?vue&type=template&id=20659c6b&scoped=true&"
import script from "./transactionRecords.vue?vue&type=script&lang=js&"
export * from "./transactionRecords.vue?vue&type=script&lang=js&"
import style0 from "./transactionRecords.vue?vue&type=style&index=0&id=20659c6b&lang=less&scoped=true&"
import style1 from "./transactionRecords.vue?vue&type=style&index=1&id=20659c6b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20659c6b",
  null
  
)

export default component.exports